/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { FDCPASettings } from './FDCPASettings';
import {
  FDCPASettingsFromJSON,
  FDCPASettingsFromJSONTyped,
  FDCPASettingsToJSON,
} from './FDCPASettings';

/**
 *
 * @export
 * @interface GlobalSettings
 */
export interface GlobalSettings {
  /**
   *
   * @type {number}
   * @memberof GlobalSettings
   */
  companyId?: number;
  /**
   *
   * @type {number}
   * @memberof GlobalSettings
   */
  dateCreated?: number;
  /**
   *
   * @type {string}
   * @memberof GlobalSettings
   */
  dateCreatedIso?: string;
  /**
   *
   * @type {number}
   * @memberof GlobalSettings
   */
  dateModified?: number;
  /**
   *
   * @type {string}
   * @memberof GlobalSettings
   */
  dateModifiedIso?: string;
  /**
   *
   * @type {FDCPASettings}
   * @memberof GlobalSettings
   */
  fdcpaSettings?: FDCPASettings;
  /**
   *
   * @type {string}
   * @memberof GlobalSettings
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof GlobalSettings
   */
  key: string;
}

/**
 * Check if a given object implements the GlobalSettings interface.
 */
export function instanceOfGlobalSettings(
  value: object,
): value is GlobalSettings {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('key' in value) || value['key'] === undefined) return false;
  return true;
}

export function GlobalSettingsFromJSON(json: any): GlobalSettings {
  return GlobalSettingsFromJSONTyped(json, false);
}

export function GlobalSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GlobalSettings {
  if (json == null) {
    return json;
  }
  return {
    companyId: json['company_id'] == null ? undefined : json['company_id'],
    dateCreated:
      json['date_created'] == null ? undefined : json['date_created'],
    dateCreatedIso:
      json['date_created_iso'] == null ? undefined : json['date_created_iso'],
    dateModified:
      json['date_modified'] == null ? undefined : json['date_modified'],
    dateModifiedIso:
      json['date_modified_iso'] == null ? undefined : json['date_modified_iso'],
    fdcpaSettings:
      json['fdcpa_settings'] == null
        ? undefined
        : FDCPASettingsFromJSON(json['fdcpa_settings']),
    id: json['id'],
    key: json['key'],
  };
}

export function GlobalSettingsToJSON(value?: GlobalSettings | null): any {
  if (value == null) {
    return value;
  }
  return {
    company_id: value['companyId'],
    date_created: value['dateCreated'],
    date_created_iso: value['dateCreatedIso'],
    date_modified: value['dateModified'],
    date_modified_iso: value['dateModifiedIso'],
    fdcpa_settings: FDCPASettingsToJSON(value['fdcpaSettings']),
    id: value['id'],
    key: value['key'],
  };
}
